/**
 * The API responds 401 when no presented accessToken maps to an active session
 * (dead/stale cookie). The cookie is httpOnly, so the SPA can't clean it up —
 * send the user to the login page instead of leaving the page half-broken.
 * 403 is a genuine permission denial and must NOT log the user out.
 */
export const redirectToLoginOn401 = (response: Response): Response => {
  if (response.status === 401 && window.location.pathname !== '/') {
    window.location.href = '/';
  }
  return response;
};
